<template>
      <div>
            <!-- Headline -->
            <div class="flex xs-12 mb2 xs-middle" slot="headline">
                  <div class="flex xs-6 xs-left fs5 lh125 fw7 c1">{{ $t("particulars") }}</div>
                  <div class="flex xs-6 xs-right xs-middle lh125 c1">
                        <!-- Update Quote Button -->
                        <j-button type="tertiary" @click="$modal.show('updateParticulars')">
                              <crm-icon name="edit" size="small" color="c2"/>
                              {{ $t("update") }}
                        </j-button>
                  </div>
            </div>

            <!-- Items -->
            <j-card class="bg5">
                  <j-list :list="computedParticulars">
                        <div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
                              <div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">{{ item.label }}</div>
                              <div class="flex xs-6 xs-left xs-middle lh125">
                                    <router-link :to="item.link" v-if="item.link">{{ item.value }}</router-link>
                                    <template v-else>{{ item.value }}</template>
                              </div>
                        </div>
                  </j-list>
                  <div
                        class="bg5 ta2 fs3 p2"
                        v-if="computedParticulars.length === 0"
                  >{{ $t("errors.no_data") }}</div>
            </j-card>

            <!-- Update Modal -->
            <core-modal name="updateParticulars" :headline="$t('update_particulars')">
                  <update-particulars :particulars="particulars" @updated="afterUpdate"/>
            </core-modal>
      </div>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"
import UpdateParticulars from "@/modules/quotes/components/UpdateParticulars"
import dayjs from "dayjs"
import get from "lodash.get"

export default {
	components: {
		JCard,
		JList,
		JButton,
		CrmIcon,
		CoreModal,
		UpdateParticulars
	},

	props: {
		particulars: {
			type: Object,
			required: true,
			default: () => {}
		}
	},

	methods: {
		afterUpdate() {
			this.$modal.hide("updateParticulars")
			this.$emit("updated")
		}
	},

	computed: {
		computedParticulars() {
			const data = this.particulars
			return [
				{ label: this.$t("quote_number"), value: data.id },
				{
					label: this.$t("client"),
					value: get(data, "holder.name"),
					link: `/${
						this.$store.state.tenantId
					}/clients/detail/${get(
						data,
						"holder.id"
					)}/overview/${get(data, "holder.__typename")}`
				},
				{
					label: this.$t("referrer"),
					value: get(data, "referrer.name", null)
				},
				{
					label: this.$t("start_date"),
					value: data.startDate
						? dayjs(data.startDate).format(
								this.$store.state.settings
									.dateFormat
						  )
						: null
				},
				{
					label: this.$t("end_date"),
					value: data.endDate
						? dayjs(data.endDate).format(
								this.$store.state.settings
									.dateFormat
						  )
						: null
				},
				{ label: this.$t("source"), value: data.source },
				{
					label: this.$t("channel"),
					value: get(data, "client.name", "")
						? get(data, "client.name", "").toUpperCase()
						: get(data, "client.id", "").toUpperCase()
				}
			]
		}
	}
}
</script>
